import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import './SubjectShare.scss';
import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LabelList, CartesianGrid } from 'recharts';
import { Percentual, MoneyFullBRL, NumberLessBRL, MoneyLessBRL } from '../../../../services';
import { SubjectShareModal } from '../subject-share-modal/SubjectShareModal';
import { QUERY_FILTER_PUBLISHER, QueryFilter } from 'src/component/shared';
import { GetCacheIfExists, SetDataToSession, HasNoFilterAppliedPublisherShare } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface ISubjectShareProps {

}

// tslint:disable-next-line:no-empty-interface
export interface ISubjectShareState {
    dialogOpen: boolean,
    customFilter: {
        isChart: boolean
    },
    isUpdate: false,

}

export interface ISubjectShareDataChart {
    subject: string;
    billing: number;
    billing_label: string;
    qtd_coupon: string;
    percent_label: string;
    percent_result: number;
    price: string;
    volume: string;
}

const PUBLISHER_SUBJECT_SHARE = gql`
query publisherSubjectShare($customFilter:  PublisherCustomFilter) {
  publisherSubjectShare(publisherCustomFilter: $customFilter) {
    subject,
    billing,
    qtd_coupon,
    percent_label,
    price,
    volume,
  }
}
`;

// statless component
const SubjectShareDataChart = ({ data }: { data: ISubjectShareDataChart[] }) => (

    <div>
    <ResponsiveContainer width="100%" height={300} >
        <BarChart
                data={data}
                margin={{ top: 5, right: 20, left: 100, bottom: 5 }}
                layout="vertical">
                <CartesianGrid vertical={false} horizontal={false} />
                <XAxis type="number" hide={true}/>
                <YAxis yAxisId="center" type="category" dataKey="subject"  tick={{fontSize: '65%'}}/>
                <Tooltip content={<SubjectShareTooltipData />} />
                <Bar yAxisId="center" dataKey="percent_result" fill="#65cc93" barSize={25} isAnimationActive={false} >
                    <LabelList dataKey="percent_label" position="right" className="recharts-label-custom-black" />
                </Bar>
            </BarChart>
    </ResponsiveContainer>
    <div style={{position: 'absolute', bottom: 8}}>
      <SubjectShareModal />
    </div>
    </div>

);

// statless component
const SubjectShareTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Assunto:</td><td className="tooltip-content">{content && content.subject}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Share:</td><td className="tooltip-content">{content && content.percent_label}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Faturamento:</td><td className="tooltip-content">{content && content.billing_label}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Volume:</td><td className="tooltip-content">{content && content.volume}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Preço Médio:</td><td className="tooltip-content">{content && content.price}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Qtde de Cupons:</td><td className="tooltip-content">{content && content.qtd_coupon}</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

const dataFilled = (data: any) => {
    return data && data.publisherSubjectShare && !!data.publisherSubjectShare.length
}

export class SubjectShare extends React.Component<ISubjectShareProps, ISubjectShareState> {
    constructor(props: ISubjectShareProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
          dialogOpen: false,
          isUpdate: false,
    }
  }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
                "limit": 6,
            }
        };

        return (
            <Query query={QUERY_FILTER_PUBLISHER} notifyOnNetworkStatusChange={true}  >
                {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {

                    let dataCache = GetCacheIfExists('publisher-data');
                    const hasNoFilterAppliedPublisher = HasNoFilterAppliedPublisherShare(clientC);

                    if( hasNoFilterAppliedPublisher && dataCache != null && dataCache.publisherSubjectShare != null ) {
                        return this.dataToRend(dataCache, false);
                    } else {
                        return (
                            <Query query={PUBLISHER_SUBJECT_SHARE} variables={QueryFilter.getFilterPublisher(clientC, jsonFilter, [])}>
                                {({ loading, error, data, client }) => {

                                    if ( hasNoFilterAppliedPublisher && data != null && data.publisherSubjectShare != null ) {
                                        if(dataCache != null && dataCache !== undefined) {
                                            dataCache.publisherSubjectShare = data.publisherSubjectShare;
                                        } else {
                                            dataCache = data;
                                        }
                                        SetDataToSession('publisher-data', dataCache);
                                    }

                                    return this.dataToRend(data,loading);
                                }}
                            </Query>
                        );
                    }
                    
                }}
            </Query>
        )
    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return (
            <Paper style={{position: "relative", height: "100%"}} className="publisher-sale-block panel-block" >
                <Typography variant="headline" className="panel-title" component="title">
                    Share por Categoria
                </Typography>
                {
                    loading
                    ?
                    <LinearProgress />
                    :
                    (
                        dataFilled(data)
                        ?
                        (<SubjectShareDataChart data={this.SubjectShareDataChartMap(data.publisherSubjectShare)} />)
                        :
                        (<Typography variant="body2" className="comparative" component="p">
                            Não há informações de vendas
                        </Typography>)
                    )
                }
            </Paper>
        );
    }

    private SubjectShareDataChartMap = (data: ISubjectShareDataChart[]) => {

        const mappedData: ISubjectShareDataChart[] = [];

        data.forEach(e => {

            const item: ISubjectShareDataChart = {
                billing: e.billing,
                billing_label: MoneyLessBRL(e.billing.toString()),
                percent_label: Percentual(e.percent_label.toString()),
                percent_result: Number(e.percent_label),
                price: MoneyFullBRL(e.price.toString()),
                qtd_coupon: NumberLessBRL(e.qtd_coupon.toString()),
                subject: e.subject === null || e.subject === undefined ? 'Outros' : e.subject,
                volume: NumberLessBRL(e.volume.toString()),
            };

            mappedData.push(item);

        });

        return mappedData;
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/subject-share/SubjectShare.tsx